
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useState } from 'react';

const ContactForm = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/contact-form-sigorta360', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div ref={ref} className="bg-white p-8 lg:p-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
      >
        <h2 className="font-poppins font-bold text-3xl lg:text-4xl mb-3 text-gray-900">
          Mesaj Gönderin
        </h2>
        <p className="font-poppins text-[15px] text-gray-600 mb-8">
          Size en kısa sürede geri dönüş yapacağız
        </p>

        <form onSubmit={handleSubmit} data-readdy-form id="contact-form-sigorta360" className="space-y-6">
          <div>
            <label htmlFor="name" className="block font-poppins text-sm font-medium text-gray-700 mb-2">
              Ad Soyad
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 font-poppins text-[15px] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#007dff]/20 focus:border-[#007dff] transition-all duration-300"
              placeholder="Adınız ve soyadınız"
            />
          </div>

          <div>
            <label htmlFor="email" className="block font-poppins text-sm font-medium text-gray-700 mb-2">
              E-posta
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 font-poppins text-[15px] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#007dff]/20 focus:border-[#007dff] transition-all duration-300"
              placeholder="ornek@email.com"
            />
          </div>

          <div>
            <label htmlFor="phone" className="block font-poppins text-sm font-medium text-gray-700 mb-2">
              Telefon
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 font-poppins text-[15px] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#007dff]/20 focus:border-[#007dff] transition-all duration-300"
              placeholder="+90 555 123 45 67"
            />
          </div>

          <div>
            <label htmlFor="message" className="block font-poppins text-sm font-medium text-gray-700 mb-2">
              Mesajınız
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={5}
              maxLength={500}
              className="w-full px-4 py-3 font-poppins text-[15px] border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#007dff]/20 focus:border-[#007dff] transition-all duration-300 resize-none"
              placeholder="Mesajınızı buraya yazın..."
            />
            <p className="font-poppins text-xs text-gray-500 mt-1">
              Maksimum 500 karakter
            </p>
          </div>

          {submitStatus === 'success' && (
            <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
              <p className="font-poppins text-sm text-green-800">
                ✓ Mesajınız başarıyla gönderildi!
              </p>
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="font-poppins text-sm text-red-800">
                ✗ Bir hata oluştu. Lütfen tekrar deneyin.
              </p>
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full bg-[#007dff] text-white font-poppins font-semibold text-[15px] px-8 py-4 rounded-lg hover:bg-[#0066cc] transition-all duration-300 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
          >
            {isSubmitting ? 'Gönderiliyor...' : 'Mesaj Gönder'}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default ContactForm;
